import React, {} from 'react';

const FeedbackListItem = ({ feedback }) => {

    const handleRowClick = () => {
        window.location.href = `/chat/${feedback.chatId}`;
    };
    return (
        <tr
            className="feedback-list-item"
            onClick={handleRowClick}
            style={{ cursor: 'pointer' }}
        >
            <td className="truncate feedback-text">{feedback.feedback || '-'}</td>
            <td>{feedback.chatId || '-'}</td>
            <td className="truncate">{feedback.mensagem || '-'}</td>
            <td>{feedback.dataHora ? new Date(feedback.dataHora).toLocaleString() : '-'}</td>
        </tr>
    );
};

export default FeedbackListItem;
